<div class="container-fluid spacer-top-navigation">
  <div class="container">
    <div class="row" [zeroLoadingIndicator]="depotTransferFacade.isLoadingForm">
      <div class="col-12">
        <div class="tile">
          <h1 class="zero-text p-huge-med mb-2">
            {{ 'portfolio-transfer.headline' | transloco }}
          </h1>
          <h5 class="mb-4">
            {{ 'portfolio-transfer.sub-headline' | transloco }}
          </h5>
          @if (depotTransferFacade.isChild) {
            <p class="mb-0">
              {{ 'portfolio-transfer.not-allowed-child' | transloco }}
            </p>
          } @else {
            <ng-container *ngTemplateOutlet="defaultContent" />
          }
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #defaultContent>
  @if (!depotTransferFacade.isLoadingForm) {
    @if (depotTransferFacade.hasLoadingFormError) {
      <p>
        {{ 'portfolio-transfer.error' | transloco }}
      </p>
    } @else {
      <p>
        {{ 'portfolio-transfer.not-allowed' | transloco }}
      </p>
    }
  }

  @if (depotTransferFacade.isAllowedToTransferPortfolio) {
    <div class="row">
      @if (depotTransferFacade.isFeatureActive === false) {
        <div class="col-12 mb-4">
          <div class="box-info box-info-primary">
            {{ 'portfolio-transfer.disabled' | transloco }}
          </div>
        </div>
      }
      @if (depotTransferFacade.isFeatureActive && depotTransferFacade.isMaintenanceTime) {
        <div class="col-12 mb-4">
          <div class="box-info box-info-primary">
            {{ 'portfolio-transfer.maintenance' | transloco }}
          </div>
        </div>
      }
      <div class="col-12 mb-2" [innerHTML]="'portfolio-transfer.text' | transloco"></div>
      @if (depotTransferFacade.portfolioTransfers?.length) {
        <div class="col-12 mb-2">
          <div class="tile">
            <p>
              <strong>{{ 'portfolio-transfer.list.headline' | transloco }}</strong>
            </p>
            <table class="table portfolio-transfer" aria-describedby="transfer-list">
              <thead>
                <tr>
                  <th>
                    {{ 'portfolio-transfer.list.sequenceNumber' | transloco }}
                  </th>
                  <th>
                    {{ 'portfolio-transfer.list.bankNameSender' | transloco }}
                  </th>
                  <th>
                    {{ 'portfolio-transfer.list.status' | transloco }}
                  </th>
                  <th>
                    {{ 'portfolio-transfer.list.lastUpdated' | transloco }}
                  </th>
                </tr>
              </thead>
              <tbody>
                @for (transfer of depotTransferFacade.portfolioTransfers; track transfer.sequenceNumber) {
                  <tr>
                    <td>
                      <div class="d-flex">
                        <div class="hidden-lg hidden-xl flex-xs-grow flex-sm-grow flex-md-grow">
                          {{ 'portfolio-transfer.list.sequenceNumber' | transloco }}
                        </div>
                        {{ transfer.sequenceNumber }}
                      </div>
                    </td>
                    <td>
                      <div class="d-flex justify-content-end">
                        <div class="hidden-lg hidden-xl flex-xs-grow flex-sm-grow flex-md-grow">
                          {{ 'portfolio-transfer.list.bankNameSender' | transloco }}
                        </div>
                        {{ transfer.bankNameSender }}
                      </div>
                    </td>
                    <td>
                      <div class="d-flex justify-content-end">
                        <div class="hidden-lg hidden-xl flex-xs-grow flex-sm-grow flex-md-grow">
                          {{ 'portfolio-transfer.list.status' | transloco }}
                        </div>
                        {{ 'portfolio-transfer.status.' + transfer.status | transloco }}
                      </div>
                    </td>
                    <td>
                      <div class="d-flex justify-content-end">
                        <div class="hidden-lg hidden-xl flex-xs-grow flex-sm-grow flex-md-grow">
                          {{ 'portfolio-transfer.list.lastUpdated' | transloco }}
                        </div>
                        {{ transfer.lastUpdated | date }}
                      </div>
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </div>
      }
      <div class="col-12 mb-4">
        @if (!depotTransferFacade.isLoadingForm) {
          @if (depotTransferFacade.hasLoadingFormError) {
            <p class="text-color-error border-error p-2">
              {{ 'portfolio-transfer.error' | transloco }}
            </p>
          } @else {
            <ng-container *ngTemplateOutlet="button" />
          }
        }
      </div>
      <div class="col-12 mb-2" [innerHTML]="'portfolio-transfer.hint' | transloco"></div>
    </div>
  }
</ng-template>

<ng-template #button>
  @if (depotTransferFacade.isFeatureActive && !depotTransferFacade.isMaintenanceTime) {
    <form
      method="POST"
      target="_blank"
      rel="noopener noreferrer"
      [action]="depotTransferFacade.majorelUrl"
      (ngSubmit)="$event.target.submit()"
    >
      <ng-container
        [ngTemplateOutlet]="formData"
        [ngTemplateOutletContext]="{
          $implicit: (depotTransferFacade.postData$ | async).customerData,
        }"
      />
      <ng-container
        [ngTemplateOutlet]="formData"
        [ngTemplateOutletContext]="{
          $implicit: (depotTransferFacade.postData$ | async).signature,
        }"
      />
      <div class="row">
        <div class="col-12 d-flex justify-content-center">
          <web-design-system-button [isSubmit]="true">{{ 'portfolio-transfer.btn' | transloco }}</web-design-system-button>
        </div>
      </div>
      <ng-template #formData let-input>
        <input type="hidden" [name]="input.name" [value]="input.value" />
      </ng-template>
    </form>
  } @else {
    <ng-container *ngTemplateOutlet="featureNotActiveBtn" />
  }
</ng-template>

<ng-template #featureNotActiveBtn>
  <div class="row">
    <div class="col-sm-6">
      <web-design-system-button size="small" [disabled]="true">
        {{ 'portfolio-transfer.btn' | transloco }}
      </web-design-system-button>
    </div>
  </div>
</ng-template>
